export const containsShiftsInCurrentLocation = (shift, jobIds) =>
  // if owner type is a location, it is an open role
  // return true since we will like to show open roles on the view
  // if owner type is a job, return true only if the job is in jobIds
  // (jobIds are in current location)
  shift?.owner?.type === 'location' ? true : jobIds.includes(shift?.owner?.id);
